import Modal from '../modules/modal.js';
const $ = window.$;

export default function Dialog(id, settings) {
	Modal.call(this, id, settings);

	this.$title = this.$outer.find('.js-dialog-title');
	this.$message = this.$outer.find('.js-dialog-message');
	this.$btnNo = this.$outer.find('.js-dialog-no');
	this.$btnYes = this.$outer.find('.js-dialog-yes');

	this.action = null;

	this.defaults = {
		titleText: 'Confirmation',
		yesText: 'Yes',
		noText: 'No'
	};

	this.postbackTriggered = function() {
		var postBackID = document.getElementById('__EVENTTARGET') ? document.getElementById('__EVENTTARGET').value : null;
		if (!this.activatorID || postBackID) return false;

		return this.activatorID.replace('MainContent_', 'ctl00$MainContent$') === postBackID;
	};

	this.afterOpen = function($activator) {
		this.triggerID = $activator.attr('id');
	};

	this.afterClose = function() {
		// reset trigger ID
		this.triggerID = '';
		this.action = null;

		// detach unused prompt button actions
		this.$btnYes.off('.dialog');
		this.$btnNo.off('.dialog');
		this.$close.off('.dialog');
	};

	this.getAction = function(elem) {
		// Determine which action to perform

		if (elem.href !== undefined) {

			if (elem.href.indexOf('javascript:') === 0) {
				// Action is a function we want to evaluate
				return new Function(elem.href.replace('javascript:', ''));
			}
			return elem.href;
		}

		if (elem.getAttribute('data-action') !== null) {
			return elem.getAttribute('data-action');
		}

		// We have an input node that we will execute the default action for
		return null;
	};

	this.setNoText = function(str) {
		var text = str || this.defaults.noText;
		this.$btnNo.text(text);
	};
	this.setYesText = function(str) {
		var text = str || this.defaults.yesText;
		this.$btnYes.text(text);
	};
	this.setTitleText = function(str) {
		var text = str || this.defaults.titleText;
		this.$title.text(text);
	};
	this.setMessageText = function(str) {
		this.$message.html(str.replace(/\n/g, '<br />'));
	};

	this.setNoAction = function(cb) {
		this.$btnNo.one('click.dialog keyup.dialog', function(e) {
			if (e.type === 'click') {
				cb();
				return;
			}
			if (e.type === 'keyup' && window.isEnterOrSpaceKey(e)) {
				e.preventDefault();
				cb();
			}
		});
	};

	this.setYesAction = function(cb) {

		this.$btnYes.one('click.dialog keyup.dialog', function(e) {
			if (e.type === 'click') {
				cb();
				return;
			}
			if (e.type === 'keyup' && window.isEnterOrSpaceKey(e)) {
				e.preventDefault();
				cb();
			}
		});
	};

	this.setCloseAction = function(cb) {
		this.$close.one('click.dialog keyup.dialog', function(e) {
			// don't execute close action for no button'
			if ($(this).hasClass('js-dialog-no')) return;

			if (e.type === 'click') {
				cb();
				return;
			}
			if (e.type === 'keyup' && window.isEnterOrSpaceKey(e)) {
				e.preventDefault();
				cb();
			}
		});
	};

	this.prompt = function(message,settings) {
		var s = settings || {};
		var defaults = {
			showYes: true,
			showNo: true
		};

		this.$btnNo.show();
		this.$btnYes.show();

		s = $.extend(defaults, s);

		/*
            Settings object
            showyes:   [boolean] show the primary action button
            showno:    [boolean] show the secondary action button 
            titleText: [string] text that overrides the default title text
            yesText:   [string] text that overrides the default yes button text
            noText:    [string] text that overrides the default no button text
            onYes:     [function] callback function to be run after "yes" has been clicked
            onNo:      [function] callback function to be run after "no" has been clicked
            onClose:   [function] callback function to be run after the "x" has been clicked to close the modal.
        */

		if (message) this.setMessageText(message);
		this.setTitleText(s.titleText);
		this.setYesText(s.yesText);
		this.setNoText(s.noText);

		if (s.showYes) {
			if (typeof s.onYes === 'function') {
				this.setYesAction(s.onYes);
			}
		} else {
			this.$btnYes.hide();
		}

		if (s.showNo) {
			if (typeof s.onNo === 'function') {
				this.setNoAction(s.onNo);
			}

		} else {
			this.$btnNo.hide();
		}

		if (typeof s.onClose === 'function') {
			this.setCloseAction(s.onClose);
		}

		// just pass this $(document) to make it happy
		this.open($(document));
	};

	if (window.isEnglish() === false) {
		var that = this;

		// update default strings with user's language
		for (let text in this.defaults) {
			if (this.defaults.hasOwnProperty(text)) {
				let val = this.defaults[text];
				window.async_translate(val)
					.then(function(strTran) {
						that.defaults[text] = strTran;
					});
			}
		}
	}
}